import { createBaseQuery } from './createBaseQuery.mjs';
import { isV5, ReactQuery, suspenseOptions } from './utils.mjs';

function createSuspenseQuery(options) {
  return isV5 ? createBaseQuery(options, ReactQuery.useSuspenseQuery) : createBaseQuery(options, ReactQuery.useQuery, suspenseOptions);
}

export { createSuspenseQuery };
//# sourceMappingURL=createSuspenseQuery.mjs.map
